.chevron-down {
  background-image: url("../images/chevron-down.svg");
  margin-top: 3px;
  width: 16px;
  height: 16px;
  user-select: none;
}

.text {
  display: flex;
  line-height: 20px;
  vertical-align: middle;
  font-size: 14px;
  color: #777;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 20px;
  text-align: left;
  padding-right: 10px;
  white-space: nowrap;
}

.icon {
  width: 20px;
  height: 20px;
  user-select: none;
  margin-right: 12px;
  background-size: contain;
}
